import type { SVGProps } from "react";

function LogoWhite(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      height="20.942"
      viewBox="0 0 81.071 20.942"
      width="81.071"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            ".geopsui.logowhite .a,.geopsui.logowhite .b{fill:#fff;} .geopsui.logowhite .b{fill-rule:evenodd;}"
          }
        </style>
      </defs>
      <g className="geopsui logowhite" transform="translate(-70.036 -303.667)">
        <g transform="translate(70.036 303.667)">
          <path
            className="a"
            d="M617.809,193.909a1.241,1.241,0,1,1-1.242,1.241A1.244,1.244,0,0,1,617.809,193.909Z"
            transform="translate(-579.279 -184.401)"
          />
          <path
            className="a"
            d="M556.095,75.347A6.163,6.163,0,1,0,550.608,72,6.227,6.227,0,0,0,556.095,75.347Zm-.233,2.071a8.24,8.24,0,1,1,8.3-6.585A8.3,8.3,0,0,1,555.862,77.419Z"
            transform="translate(-515.446 -60.924)"
          />
          <path
            className="b"
            d="M105.428,104.82H99.6c-2.509,0-4.552,1.733-4.552,3.863v4.731c0,2.13,2.043,3.863,4.552,3.863h8.6v1.483c0,1.153-1.246,2.091-2.779,2.091H96.1v.012c-.026,0-.05-.008-.076-.008a.883.883,0,1,0,0,1.765c.026,0,.05-.006.076-.008v.011l9.331,0c2.51,0,4.552-1.733,4.552-3.863V108.683C109.98,106.553,107.938,104.82,105.428,104.82Zm2.779,10.686H99.6c-1.532,0-2.779-.938-2.779-2.091v-4.731c0-1.153,1.247-2.092,2.779-2.092h5.824c1.533,0,2.779.938,2.779,2.092Z"
            transform="translate(-95.052 -101.681)"
          />
          <path
            className="b"
            d="M337.672,111.946v-3.263c0-2.13-2.042-3.863-4.551-3.863H327.3c-2.51,0-4.552,1.733-4.552,3.863v4.731c0,2.13,2.041,3.863,4.552,3.863h9.489a.886.886,0,1,0,0-1.772H327.3c-1.532,0-2.779-.938-2.779-2.091v-1.477ZM327.3,106.592h5.824c1.532,0,2.778.938,2.778,2.092v1.483H324.518v-1.483C324.518,107.53,325.765,106.592,327.3,106.592Z"
            transform="translate(-306.465 -101.681)"
          />
          <path
            className="b"
            d="M805.148,104.82h-5.823c-2.51,0-4.552,1.733-4.552,3.863v12.905a.886.886,0,0,0,1.773,0v-4.311h8.6c2.51,0,4.552-1.733,4.552-3.863v-4.731C809.7,106.553,807.659,104.82,805.148,104.82Zm-8.6,3.863c0-1.153,1.246-2.092,2.779-2.092h5.823c1.533,0,2.78.938,2.78,2.092v4.731c0,1.153-1.247,2.091-2.78,2.091h-8.6Z"
            transform="translate(-744.743 -101.681)"
          />
          <path
            className="b"
            d="M1031.151,110.022a.446.446,0,0,0-.062-.006h-.079a.49.49,0,0,0-.106,0h-4.764l0,0-3.03,0a1.768,1.768,0,0,1-.022-3.536h10.5a.886.886,0,1,0,0-1.771h-10.476a3.54,3.54,0,0,0-.023,7.079l4.683,0h3.251a1.8,1.8,0,0,1-.086,3.6h0l-10.469,0a.886.886,0,1,0,0,1.772h10.325a.088.088,0,0,0,.036,0l.045,0c.029,0,.059,0,.089,0a3.57,3.57,0,0,0,.191-7.136Zm-.191.168"
            transform="translate(-953.466 -101.576)"
          />
        </g>
      </g>
    </svg>
  );
}
export default LogoWhite;
